import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";
import { useAuth } from "@/contexts/AuthContext";

export const useTeamMemberProfile = (userId: string | undefined) => {
  const { user } = useAuth();
  return useQuery({
    queryKey: ["team_member_profile", userId],
    queryFn: async () => {
      const { data, error } = await supabase
        .from("user_profiles")
        .select("*, roles(name, color, base_level, permissions)")
        .eq("user_id", userId!)
        .single();
      if (error) throw error;
      return data as any;
    },
    enabled: !!user && !!userId,
  });
};

export const useTeamMemberProjects = (userId: string | undefined) => {
  const { user } = useAuth();
  return useQuery({
    queryKey: ["team_member_projects", userId],
    queryFn: async () => {
      const { data, error } = await supabase
        .from("project_assignments")
        .select("*, projects(id, name, project_number, status, project_type)")
        .eq("user_id", userId!);
      if (error) throw error;
      return data as any[];
    },
    enabled: !!user && !!userId,
  });
};

export const useTeamMemberActivity = (userId: string | undefined) => {
  const { user } = useAuth();

  const approvals = useQuery({
    queryKey: ["team_member_approvals", userId],
    queryFn: async () => {
      const { data, error } = await supabase
        .from("approval_requests")
        .select("id, title, request_type, status, created_at, project_id")
        .eq("requested_by", userId!)
        .order("created_at", { ascending: false })
        .limit(20);
      if (error) throw error;
      return data as any[];
    },
    enabled: !!user && !!userId,
  });

  return { approvals };
};
